<template>
  <div class="body">
    <div class="container" id="formContent">
      <div class="updown">
        <img style="width: 12vw" :src="require('../img/albinuta.png')"/>
      </div>
      <h3>Bine ai venit!</h3>
      <p> Aici vei găsi o modalitate rapidă și eficientă de recapitulare a
        noțiunilor esențiale din matematica de gimnaziu și un excelent
        instrument în pregătirea examenului de evaluare națională. </p>
      <div>
        <router-link :to="{name: 'login'}">
          <button type="button" class="buton btn" style="margin-right: 0.5vh; margin-bottom: 0.5vh;">
            Login
          </button>
        </router-link>

        <router-link :to="{name: 'signup'}">
          <button type="button" class="buton btn" style="margin-left: 0.5vh; margin-bottom: 0.5vh;">
            Creare cont
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.updown {
    animation-name: floating;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}

@keyframes floating {
    from { transform: translate(0,  0px); }
    50%  { transform: translate(-0, -10px) rotate(5deg);}
    to   { transform: translate(0, -0px); }
}

.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  min-width: 70%;
  max-width: 70%;
  min-height: 50%;
  max-height: 90%;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}
</style>
